import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useCallback, useMemo, useState } from "react";
import * as Yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useAuth } from "../../hooks/useAuth";
import { SignInCredentials } from "../../types/session";
import { useStyles } from "./styles";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ImageDsMarketing from "../../assets/preload/logo.png";
import { useToast } from "../../hooks/useToast";

type FormValues = {
  email: string;
  password: string;
};

const validationSchema = Yup.object().shape({
  email: Yup.string().required("Digite seu e-mail").email("Email inválido"),
  password: Yup.string().required("Digite sua senha"),
});

export function SignIn() {
  const [hidePassword, setHidePassword] = useState<boolean>(true);

  const toast = useToast();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const styles = useStyles();

  const handleSignIn = useCallback(
    async (values: SignInCredentials) => {
      try {
        await signIn(values);
      } catch (err: any) {
        toast.show(err.response.data?.message, { severity: "error" });
      }
    },
    [signIn, toast]
  );

  const typeInputPassword = useMemo(() => {
    if (hidePassword) {
      return "password";
    }
    return undefined;
  }, [hidePassword]);

  const formik = useFormik<FormValues>({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: handleSignIn,
  });

  return (
    <div className={styles.root}>
      <div className={styles.paper}>
        <div style={{ marginBottom: "2vh" }}>
          <img width={350} alt="" src={ImageDsMarketing} />
        </div>
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          <TextField
            fullWidth
            id="email"
            variant="outlined"
            label="Email"
            name="email"
            required
            autoComplete="email"
            autoFocus
            onChange={formik.handleChange("email")}
            error={Boolean(formik.errors.email)}
            helperText={formik.errors.email}
            margin="normal"
          />
          <TextField
            fullWidth
            id="password"
            variant="outlined"
            label="Senha"
            required
            name="password"
            onChange={formik.handleChange("password")}
            error={Boolean(formik.errors.password)}
            helperText={formik.errors.password}
            margin="normal"
            autoComplete="current-password"
            type={typeInputPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setHidePassword((prev) => !prev)}>
                    {hidePassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            disabled={formik.isSubmitting}
            fullWidth
            size="large"
            variant="contained"
            className={styles.submit}
            type="submit"
          >
            {formik.isSubmitting ? (
              <CircularProgress size={24} className={styles.progress} />
            ) : (
              "Entrar"
            )}
          </Button>
        </form>
        <Button
          onClick={() => navigate("/recover")}
          className={styles.retrieveAccount}
          fullWidth
          size="large"
          variant="text"
        >
          Esqueceu a senha?
        </Button>
      </div>
      <div className={styles.image}>
        <div className={styles.LoginMaskImg} />
      </div>
    </div>
  );
}
